import React from 'react';
import { Row, Col } from 'react-bootstrap';
import Layout from './Layout';
import FormPageTitle from './FormPageTitle';
import BackButton from './BackButton';

interface FormPageProps {
  /** Заголовок страницы */
  title: string;
  /** Опциональная подсказка рядом с заголовком (иконка ?) */
  helperContent?: string;
  /** Маршрут для кнопки «Назад» (если задан — кнопка показывается вверху) */
  backFallbackRoute?: string;
  /** Содержимое: обычно Form с FormCard внутри */
  children: React.ReactNode;
}

/**
 * Единая обёртка для страниц форм (category, users, telegram-access).
 * Один визуал: Layout + кнопка «Назад» (опционально) + заголовок с опциональным хелпером.
 */
export const FormPage: React.FC<FormPageProps> = ({ title, helperContent, backFallbackRoute, children }) => (
  <Layout>
    {backFallbackRoute && (
      <Row className="my-2">
        <Col xs={12}>
          <BackButton fallbackRoute={backFallbackRoute} />
        </Col>
      </Row>
    )}
    <FormPageTitle title={title} helperContent={helperContent} />
    {children}
  </Layout>
);

export default FormPage;
